module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal modal-backdrop fade slide-up show",
    style: (_vm.modalStyle),
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.sizeClass
  }, [_c('div', {
    staticClass: "modal-content-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header clearfix text-left"
  }, [(_vm.showClose) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "iconfont icon-close fs-14"
  })]) : _vm._e(), _vm._t("title", [_c('h5', [_vm._v(_vm._s(_vm.title)), _c('span', {
    staticClass: "semi-bold"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])], 2), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), (_vm.$slots.footer) ? _c('div', {
    staticClass: "modal-footer clearfix text-right"
  }, [_vm._t("footer")], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e6f955b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmartDialog/index.vue
// module id = 1728
// module chunks = 1